module.exports = __webpack_public_path__ + "static/media/circle-importUser.5d324800.svg";